export interface ICollection {
  id: string;
  name: string;
  type: string;
  isPremium: boolean;
  appIds: string[];
};

export enum CollectionFlag {
  PREMIUM = 'PREMIUM'
};
